import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { GasAutocompleteComponent } from './wrapper/gas-autocomplete.component';
import { GasAutocompleteDropdownComponent } from './dropdown/gas-autocomplete-dropdown.component';
import { GasAutocompleteDropdownDirective } from './dropdown/gas-autocomplete-dropdown.directive';
import { GasIconsModule } from '../../utils/gas-icons/gas-icons.module';
import { GasScrollModule } from '../../utils/gas-scroll/gas-scroll.module';
import { GasInputModule } from '../gas-input/gas-input.module';
import { GasClickOutsideDirectiveModule } from '../../utils/click-outside-directive/gas-click-outside.module';
import { GasObjectFilterModule } from '../../utils/gas-object-filter-pipe/gas-object.filter.module';
import { GasSpinnerModule } from './../../common/gas-spinner/gas-spinner.module';

const COMPONENTS = [
  GasAutocompleteComponent,
  GasAutocompleteDropdownComponent,
];

const DIRECTIVES = [
  GasAutocompleteDropdownDirective,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    GasIconsModule,
    GasScrollModule,
    GasInputModule,
    GasClickOutsideDirectiveModule,
    GasObjectFilterModule,
    GasSpinnerModule,
  ],
  declarations: [
    COMPONENTS,
    DIRECTIVES,
  ],
  exports: [
    COMPONENTS,
    DIRECTIVES,
  ],
  entryComponents: [
    GasAutocompleteDropdownComponent,
  ],
})
export class GasAutocompleteModule { }
